import React from 'react';
import './styles.css';

const Why = () => {
    return (
        <div className='why-content'>
            <h1>Time to speed up your podcast production.</h1>
            <h2 className='main-blue'>Do you ever feel like you're searching for needles in a haystack? Stop wasting time stalking people and researching their achievements only to invite them and get a rejection.</h2>
        </div>
    )
}

export default Why; 